import Phaser from 'phaser';
import getConfig from '@config/baseConfig';
import sceneDefs from '@config/scenes';

export function initializeGame(gameState = {}) {
  const config = getConfig();
  const game = new Phaser.Game(config);

  game.__gameState = gameState;

  sceneDefs.forEach(({ key, scene, autoStart }) => {
    game.scene.add(key, scene, autoStart || false);
  });

  return game;
}
